var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"label":_vm.$t(`filters.labels.${_vm.name}`)},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }